import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M8 .667a4.667 4.667 0 0 0-4.667 4.666c0 2.235-.478 3.623-.918 4.431a4 4 0 0 1-.586.83 2 2 0 0 1-.205.188l-.002.002A.667.667 0 0 0 2 12h12a.667.667 0 0 0 .377-1.216l-.001-.002-.035-.027a2 2 0 0 1-.17-.162 4 4 0 0 1-.586-.829c-.44-.808-.918-2.196-.918-4.43A4.667 4.667 0 0 0 8 .666m4.567 10H3.433q.076-.124.152-.264c.56-1.026 1.082-2.638 1.082-5.07a3.333 3.333 0 0 1 6.666 0c0 2.432.522 4.044 1.082 5.07q.075.138.152.264",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.423 13.666a.667.667 0 1 0-1.153.668 2 2 0 0 0 3.46 0 .667.667 0 1 0-1.153-.668.667.667 0 0 1-1.154 0"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })